import React from 'react'
import Dropdown from 'components/ui/Selector'
import { ContentLangs } from 'config'
import { Button } from '@/components/ui/button'
import { X } from 'lucide-react'

const LANG_OPTIONS = ContentLangs.filter((item) => item.code > 0)

const DropdownLang = ({ value, update }) => {
  const hasValue = value != null && Number(value) > 0

  return (
    <div className="relative">
      <Dropdown
        datas={LANG_OPTIONS}
        showCode
        labelName="Lang"
        value={hasValue ? value : null}
        update={update}
        placeholder="All"
      />
      {hasValue ? (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          title="Clear lang"
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            update(null)
          }}
          className="absolute right-8 top-1/2 h-6 w-6 -translate-y-1/2 p-0"
        >
          <X className="h-4 w-4" />
        </Button>
      ) : null}
    </div>
  )
}

export default DropdownLang
